var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftoutlinedone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41379 6.64471L7.36379 11.5947C7.4593 11.687 7.53548 11.7973 7.58789 11.9193C7.6403 12.0413 7.66788 12.1725 7.66904 12.3053C7.67019 12.4381 7.64489 12.5698 7.59461 12.6927C7.54433 12.8156 7.47007 12.9272 7.37618 13.0211C7.28229 13.115 7.17064 13.1893 7.04774 13.2395C6.92484 13.2898 6.79316 13.3151 6.66039 13.314C6.52761 13.3128 6.39639 13.2852 6.27438 13.2328C6.15238 13.1804 6.04203 13.1042 5.94979 13.0087L0.292786 7.35171C0.105315 7.16418 0 6.90988 0 6.64471C0 6.37955 0.105315 6.12524 0.292786 5.93771L5.94979 0.280712C6.13839 0.0985537 6.39099 -0.00224062 6.65319 3.78026e-05C6.91538 0.00231622 7.1662 0.107485 7.3516 0.292893C7.53701 0.478301 7.64218 0.729114 7.64446 0.991311C7.64674 1.25351 7.54594 1.50611 7.36379 1.69471L2.41379 6.64471Z",
    fill: "#5F6D8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftoutlinedone);
export default __webpack_public_path__ + "static/media/Leftoutlinedone.4c6297b48673c90cb1e793bf3d68c16d.svg";
export { ForwardRef as ReactComponent };